import React from "react"

const LinkContext = React.createContext(undefined);
export default LinkContext;
